export const Avatar = (props) => {
    return (
        <img {...props} alt="" src={require(`../../assets/images/avatars/${props.avatar_id}.png`)} />
    )
}